"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _compose = _interopRequireDefault(require("lodash/fp/compose"));
var _concat = _interopRequireDefault(require("lodash/fp/concat"));
var _uniq = _interopRequireDefault(require("lodash/fp/uniq"));
var _remove = _interopRequireDefault(require("lodash/fp/remove"));
var _eq = _interopRequireDefault(require("lodash/fp/eq"));
var _isNil = _interopRequireDefault(require("lodash/fp/isNil"));
var _isFunction = _interopRequireDefault(require("lodash/fp/isFunction"));
var _omit = _interopRequireDefault(require("lodash/fp/omit"));
var _eventHandler = require("@active/react-utils/eventHandler");
var _CheckboxGroupContext = require("./CheckboxGroupContext");
var _utils = require("../Form/utils");
var _excluded = ["children", "className", "defaultValue", "disabled", "hasError", "horizontal", "value", "onBlur", "onChange", "isinform"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var addValue = function addValue(value) {
  return (0, _compose["default"])(_uniq["default"], (0, _concat["default"])(value));
};
var removeValue = function removeValue(value) {
  return (0, _remove["default"])((0, _eq["default"])(value));
};
var isControlled = function isControlled(value, onChange) {
  return !(0, _isNil["default"])(value) && (0, _isFunction["default"])(onChange);
};
var CheckboxGroup = function CheckboxGroup(_ref, ref) {
  var children = _ref.children,
    className = _ref.className,
    _ref$defaultValue = _ref.defaultValue,
    defaultValue = _ref$defaultValue === void 0 ? [] : _ref$defaultValue,
    disabled = _ref.disabled,
    _ref$hasError = _ref.hasError,
    hasError = _ref$hasError === void 0 ? false : _ref$hasError,
    horizontal = _ref.horizontal,
    value = _ref.value,
    onBlur = _ref.onBlur,
    onChange = _ref.onChange,
    isinform = _ref.isinform,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useState = (0, _react.useState)(defaultValue),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    interalValue = _useState2[0],
    setInteralValue = _useState2[1];
  var ctx = (0, _react.useMemo)(function () {
    var val;
    var setVal;
    if (isControlled(value, onChange)) {
      val = value || [];
      setVal = onChange;
    } else {
      val = interalValue;
      setVal = setInteralValue;
    }
    return {
      value: val,
      disabled: disabled,
      hasError: hasError,
      onChange: function onChange(e) {
        setVal(e.target.checked ? addValue(e.target.value)(val) : removeValue(e.target.value)(val), !!isinform);
      }
    };
  }, [interalValue, value, disabled, hasError, onChange]);
  var handleBlur = (0, _eventHandler.useAbsoluteBlurHandler)(function (e) {
    onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
  }, [onBlur]);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    ref: ref,
    "data-testid": "checkbox-group-root",
    role: "group",
    className: (0, _classnames["default"])('checkbox-group', {
      'checkbox-group-vertical': !horizontal
    }, className),
    onBlur: handleBlur
  }, (0, _omit["default"])(['aria-required'])((0, _utils.omitFormProps)(rest))), /*#__PURE__*/_react["default"].createElement(_CheckboxGroupContext.CheckboxGroupProvider, {
    value: ctx
  }, children));
};
var Composed = (0, _compose["default"])(_react.memo, _react["default"].forwardRef)(CheckboxGroup);
var _default = exports["default"] = Composed;